import React from 'react';
import { Container, Row, Col, Breadcrumb, Alert } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

interface PageLayoutProps {
  title: string;
  children: React.ReactNode;
  breadcrumbs?: Array<{ text: string; href?: string }>;
  alert?: { variant: string; message: string };
  onAlertDismiss?: () => void;
  fluid?: boolean;
  className?: string;
  headerActions?: React.ReactNode;
  sidebar?: React.ReactNode;
  sidebarWidth?: number;
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  title,
  children,
  breadcrumbs,
  alert,
  onAlertDismiss,
  fluid = false,
  className = '',
  headerActions,
  sidebar,
  sidebarWidth = 3,
}) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      
      <Container fluid={fluid} className={className}>
        {/* Breadcrumbs */}
        {breadcrumbs && breadcrumbs.length > 0 && (
          <Row className="mb-3">
            <Col>
              <Breadcrumb>
                {breadcrumbs.map((crumb, index) => (
                  <Breadcrumb.Item
                    key={index}
                    href={crumb.href}
                    active={index === breadcrumbs.length - 1}
                  >
                    {crumb.text}
                  </Breadcrumb.Item>
                ))}
              </Breadcrumb>
            </Col>
          </Row>
        )}

        {/* Alert */}
        {alert && (
          <Row className="mb-3">
            <Col>
              <Alert
                variant={alert.variant}
                dismissible={!!onAlertDismiss}
                onClose={onAlertDismiss}
              >
                {alert.message}
              </Alert>
            </Col>
          </Row>
        )}

        {/* Header */}
        <Row className="mb-4">
          <Col>
            <div className="d-flex justify-content-between align-items-center">
              <h1 className="mb-0">{title}</h1>
              {headerActions && (
                <div className="d-flex gap-2">
                  {headerActions}
                </div>
              )}
            </div>
          </Col>
        </Row>

        {/* Content */}
        <Row>
          {sidebar ? (
            <>
              <Col md={sidebarWidth}>
                {sidebar}
              </Col>
              <Col md={12 - sidebarWidth}>
                {children}
              </Col>
            </>
          ) : (
            <Col>
              {children}
            </Col>
          )}
        </Row>
      </Container>
    </>
  );
}; 
